import PageLayout from '@/components/PageLayout';
import StandingsTable from '@/components/StandingsTable';
import { TeamsStandingsQuery, TeamsStandingsQueryVariables } from 'queries';
import HeadlinesModule from '@/components/modules/HeadlinesModule';
import PageHeader from '@/components/PageHeader';
import ContentSection, { ContentSectionFlushContent, ContentSectionFooterButton } from '@/components/ContentSection';
import ApplicationShareButton from 'containers/ApplicationContainer/components/ApplicationShareButton';
import SchoolYearFilter from '@/components/filters/SchoolYearFilter';
import Page from '@/components/Page';
import { entryPoint } from 'react_rails/entryPoint';
import TeamSubNav from '@/components/subNavs/TeamSubNav';
import filterArticles from 'helpers/filterArticles';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import StnVideoAd from '@/components/ads/StnVideoAd';
import useScreenSize from 'hooks/useScreenSize';
import FilterSection from '@/components/FilterSection';
import OutbrainAd from '@/components/ads/OutbrainAd';

interface TeamStandingsPageProps {
  query: TeamsStandingsQuery;
  variables: TeamsStandingsQueryVariables;
}

export default entryPoint(function Standings({ query: { team }, variables: { schoolYear } }: TeamStandingsPageProps) {
  const { isSmallScreen } = useScreenSize();
  // this is for TypeScript -> controller should 404 if no league
  if (!team.league) throw 'League not found!';

  return (
    <Page subNav={<TeamSubNav team={team} />}>
      <PageLayout
        sidebar={
          <>
            <MinuteMediaAd placement="SIDEBAR" />
            {team.articles.nodes.length > 0 && <HeadlinesModule articles={filterArticles(team.articles.nodes)} />}
            <MinuteMediaAd placement="SIDEBAR_2" />
          </>
        }
      >
        {!isSmallScreen && (
          <div style={{ width: '100%' }}>
            <StnVideoAd placement="INLINE" />
          </div>
        )}
        <ContentSection>
          <PageHeader right={<ApplicationShareButton />}>{team.league.label} Standings</PageHeader>
          <FilterSection>
            <SchoolYearFilter value={schoolYear} />
          </FilterSection>
          <ContentSectionFlushContent>
            <StandingsTable isHighlighted={({ team: { id } }) => id === team.id} teamStandings={team.league.teamStandings} />
          </ContentSectionFlushContent>
          <ContentSectionFooterButton href={team.league.webPath}>Visit {team.league.label} Profile</ContentSectionFooterButton>
          <div style={{ width: '100%', paddingTop: '20px' }}>
            <MinuteMediaAd placement="IN_FEED" />
          </div>
        </ContentSection>
        <OutbrainAd />
      </PageLayout>
    </Page>
  );
});
